import React, { useEffect, useState } from 'react';
import {
    Box,
    Card,
    Grid,
    Typography,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    IconButton,
    TablePagination,
    TextField,
    Paper,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { toast } from 'react-toastify';
import { db } from '../../firebase';
import { collection, query, where, onSnapshot, deleteDoc, doc, getDocs, updateDoc, orderBy } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import Shopheader from '../Shop/Shopheader';
import Mashalheader from '../Mashal/Mashalheader';
import Wholesalerheader from '../Wholesale/Wholesaleheader';
import moment from 'moment/moment';
import PrintIcon from '@mui/icons-material/Print';


export default function Viewsale() {
    const { category } = useParams();
    const navigate = useNavigate();

    const [sales, setsales] = useState([]);
    const [customers, setcustomers] = useState([]);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    // ---------------- FETCH customers ----------------
    const fetchcustomers = async () => {
        try {
            const snap = await getDocs(collection(db, 'customers'));
            const CustomerData = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
            setcustomers(CustomerData);
        } catch (error) {
            toast.error(error.message);
        }
    };

    // ---------------- FETCH sales ----------------
    const fetchsales = () => {
        try {
            const q = query(collection(db, 'sales'), where('category', '==', category), orderBy('SaleNo', 'desc'));
            onSnapshot(q, (snap) => {
                const data = snap.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setsales(data);
            });
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        fetchcustomers();
        fetchsales();
    }, [category]);

    const handleDelete = async (saleId) => {
        if (!window.confirm('Are you sure you want to delete this Sale?')) return;

        try {
            // 1. Delete related Sale items
            const itemsSnap = await getDocs(
                query(collection(db, 'salesitems'), where('saleid', '==', saleId))
            );
            for (const docItem of itemsSnap.docs) {
                await deleteDoc(doc(db, 'salesitems', docItem.id));
            }

            // 2. Delete related Customer account entries
            const accountsSnap = await getDocs(
                query(collection(db, 'Customeraccounts'), where('saleid', '==', saleId))
            );
            let customerId = null;
            for (const docAcc of accountsSnap.docs) {
                customerId = docAcc.data().customerId; // save customerId to update totals
                await deleteDoc(doc(db, 'Customeraccounts', docAcc.id));
            }

            // 3. Delete related Customer payment history (if you want to delete payments for this Sale)
            if (customerId) {
                const paymentsSnap = await getDocs(
                    query(collection(db, 'customerpaymenthistory'), where('customerId', '==', customerId))
                );
                for (const docPay of paymentsSnap.docs) {
                    if (docPay.data().saleId === saleId) {
                        await deleteDoc(doc(db, 'customerpaymenthistory', docPay.id));
                    }
                }
            }

            // 4. Delete Sale document
            await deleteDoc(doc(db, 'sales', saleId));

            // 5. Update Customer totals
            if (customerId) {
                const salesSnap = await getDocs(
                    query(collection(db, 'sales'), where('customerId', '==', customerId))
                );
                const totalSale = salesSnap.docs.reduce((acc, doc) => acc + parseFloat(doc.data().grandTotal || 0), 0);

                const paymentsSnap = await getDocs(
                    query(collection(db, 'customerpaymenthistory'), where('customerId', '==', customerId))
                );
                const totalPaid = paymentsSnap.docs.reduce((acc, doc) => acc + parseFloat(doc.data().amount || 0), 0);

                const remaining = totalSale - totalPaid;

                // Update Customeraccounts collection if needed
                const CustomerAccountsSnap = await getDocs(
                    query(collection(db, 'Customeraccounts'), where('customerId', '==', customerId))
                );
                for (const docAcc of CustomerAccountsSnap.docs) {
                    await updateDoc(doc(db, 'Customeraccounts', docAcc.id), {
                        grandTotal: totalSale,
                        paidTotal: totalPaid,
                        remainingTotal: remaining,
                    });
                }
            }

            toast.success('sale and related data deleted successfully');
        } catch (error) {
            toast.error(error.message);
        }
    };



    const handleEdit = (saleId) => {
        navigate(`/edit-sale/${category}/${saleId}`);
    };

    // ---------------- TABLE PAGINATION ----------------
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // ---------------- FILTERED DATA ----------------
    const filteredsales = sales.filter((p) => {
        const CustomerName = customers.find((v) => v.id === p.customerId)?.name || '';
        return CustomerName.toLowerCase().includes(search.toLowerCase());
    });

    const displayedsales = filteredsales.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    const handlePrint = (saleId) => {
        // Option 1: open in new tab
        window.open(`/print-invoice/${saleId}`, "_blank");

        // Option 2: if you already have a PrintInvoice component and want to navigate
        // navigate(`/print-invoice/${category}/${saleId}`);
    };

    return (
        <Box p={2} mt={8}>
            {category === "shop" && <Shopheader />}
            {category === "mashal" && <Mashalheader />}
            {category === "wholesaler" && <Wholesalerheader />}

            <Typography variant="h5" fontWeight="bold" mb={2}>
                विक्री बघा  ({category})
            </Typography>

            <Card sx={{ p: 2, mb: 2 }}>
                <TextField
                    label="Search by Customer"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    size="small"
                />
            </Card>
            <Box>

                <Card sx={{ p: 2, overflowX: "auto" }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Action</TableCell>
                                <TableCell>बिल नं </TableCell>
                                <TableCell>ग्राहक </TableCell>
                                <TableCell>दिनांक </TableCell>
                                <TableCell>ग्रँड टोटल </TableCell>
                                <TableCell>जमा </TableCell>
                                <TableCell>बाकी </TableCell>
                                <TableCell>पेमेंट टाईप </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayedsales.map((p) => {
                                const CustomerName = customers.find((v) => v.id === p.customerId)?.name || p.customerId;
                                return (
                                    <TableRow key={p.id}>
                                        <TableCell>
                                            <IconButton color="secondary" onClick={() => handlePrint(p.id)}>
                                                <PrintIcon />
                                            </IconButton>
                                            <IconButton color="primary" onClick={() => handleEdit(p.id)}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => handleDelete(p.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell>{p.SaleNo}</TableCell>
                                        <TableCell>{CustomerName}</TableCell>
                                        <TableCell>{moment(p.SaleDate).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell>{p.grandTotal}</TableCell>
                                        <TableCell>{p.paidAmount}</TableCell>
                                        <TableCell>{p.remaining}</TableCell>
                                        <TableCell>{p.paytype}</TableCell>

                                    </TableRow>
                                );
                            })}
                            {filteredsales.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={8} align="center">
                                        No sales found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                    <TablePagination
                        component="div"
                        count={filteredsales.length}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        rowsPerPageOptions={[5, 10, 25]}
                    />
                </Card>
            </Box>
        </Box>
    );
}
